import i18n from "i18n";

const columns = [
  {
    name: "check",
    pill: false,
    title: "",
    mobileTag: i18n.t("select"),
    checkbox: true,
    tooltip: false,
  },
  {
    name: "id",
    pill: false,
    title: "",
    mobileTag: "",
    checkbox: false,
    hideColumn: true,
  },
  {
    name: "name",
    pill: false,
    title: i18n.t("name").toUpperCase(),
    mobileTag: `${i18n.t("name")}:`,
  },
  {
    name: "tag",
    pill: false,
    title: i18n.t("tag").toUpperCase(),
    mobileTag: `${i18n.t("tag")}:`,
  },
  {
    name: "lote",
    pill: false,
    title: i18n.t("batch").toUpperCase(),
    mobileTag: `${i18n.t("batch")}:`,
  },
  {
    name: "code",
    pill: false,
    title: i18n.t("code").toUpperCase(),
    mobileTag: `${i18n.t("code")}:`,
  },,
  {
    name: "fecha_vencimiento",
    pill: false,
    title: i18n.t("expiration.date").toUpperCase(),
    mobileTag: `${i18n.t("expiration.date")}:`,
  },

];
export default columns;
